import React from "react";

const Index: React.FC<any> = (props: any) => {
  return <>{props.children}</>;
};

export default Index;
